import { useState } from 'react';
import { Drawer, Pagination, Box, ButtonGroup } from 'components/ui';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { FilterProvider, useFilter, initInspectionSubjectFilterValues } from 'contexts/filter';
import { DividerContainer } from 'components/styles_components/container';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import FilterForm from 'components/inspection_subject/filter_form';
import FilterTags from 'components/filter/tags';
import InfoContainer from 'components/info_container';
import CreateButton from 'components/inspection_subject/button/create';
import FilterButton from 'components/inspection_subject/button/filter';
import InspectionSubjectQuery from 'queries/inspection_subject/index';
import Index from 'components/inspection_subject/index';

const IndexContainer = ({ placeId, overInspectionSubjectsLimit = undefined }) => {
  const { page, onPageChange } = usePaginate();
  const { inspectionSubjectsFilter, setInspectionSubjectsFilter } = useFilter();
  const setError = useError();
  const [filterVisible, setFilterVisible] = useState(false);
  const [sortBy, setSortBy] = useState('name_asc');
  const {
    data = {
      space: { overInspectionSubjectsLimit: false, adminRole: true },
      inspectionSubjects: { inspectionSubjects: [] },
    },
    loading,
  } = useQuery(InspectionSubjectQuery, {
    variables: {
      ...inspectionSubjectsFilter,
      page: page,
      placeId: placeId,
      sortBy: sortBy,
    },
    fetchPolicy: 'no-cache',
    onError: () => {
      setError('error.inspection_subject.index');
    },
  });

  if (overInspectionSubjectsLimit === undefined) {
    overInspectionSubjectsLimit = data.space.overInspectionSubjectsLimit;
  }

  return (
    <FilterProvider>
      {filterVisible && (
        <Drawer
          anchor="right"
          open={filterVisible}
          onClose={() => {
            setFilterVisible(false);
          }}
        >
          <FilterForm
            initialValues={inspectionSubjectsFilter}
            defaultValues={initInspectionSubjectFilterValues}
            onSubmit={(values) => {
              onPageChange(1);
              setFilterVisible(false);
              setInspectionSubjectsFilter(values);
            }}
            onClose={() => {
              setFilterVisible(false);
            }}
          />
        </Drawer>
      )}
      <Box display="flex" justifyContent="flex-end">
        <ButtonGroup>
          <CreateButton
            overInspectionSubjectsLimit={overInspectionSubjectsLimit}
            adminRole={data.space.adminRole}
            placeId={placeId}
          />
          <FilterButton
            onClick={() => setFilterVisible(!filterVisible)}
            initPlaceFilterValues={initInspectionSubjectFilterValues}
            inspectionSubjectsFilter={inspectionSubjectsFilter}
          />
        </ButtonGroup>
      </Box>
      <FilterTags
        filterValues={inspectionSubjectsFilter}
        defaultValues={initInspectionSubjectFilterValues}
        onFilterChange={setInspectionSubjectsFilter}
      />
      <InfoContainer
        visible={!loading && data.inspectionSubjects.inspectionSubjects.length === 0}>
        <FormattedMessage id="empty.inspection_subjects.title.short" />
      </InfoContainer>
      <Index
        loading={loading}
        inspectionSubjects={data.inspectionSubjects}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
      <Box display="flex" justifyContent="center">
        {data.inspectionSubjects.inspectionSubjectsTotalPages > 1 && (
          <Pagination
            count={data.inspectionSubjects.inspectionSubjectsTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
      <DividerContainer />
    </FilterProvider>
  );
};

export default IndexContainer;
